export default function Home({loggedIn}) {
    return (
        <section id="home">
            <h2 id="home-title">Welcome to Fitness Tracker!</h2>
            <img src="./home_image.jpeg" alt="fitness" />
            {
                loggedIn ? <h6>Get started!</h6> : <h6>Log in to get started!</h6>
            }
        </section>
    )
}